import { OrderOption } from "PFTypes";

import { WorkOpportunitiesTab } from "../constants/work_opportunities_tab";
import { OrderData } from "../contexts/marketplace_context.types";

export const getTabOrder = (
  orderData: OrderData,
  tab: WorkOpportunitiesTab,
  disableOrder: boolean = false
): OrderOption | undefined => {
  if (disableOrder) {
    return undefined;
  }

  return orderData.tab === tab && !!orderData.order ? orderData.order : undefined;
};
